import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import PingTracker from 'bundles/degree-description/components/shared/PingTracker';
import ConsumerPageGuard from 'bundles/degree-description/pages/consumer/ConsumerPageGuard';
import { DegreePageContent } from 'bundles/degree-description/pages/consumer/degree-description-page/DegreePageContent';
import { DegreeDescriptionEoiStateProvider } from 'bundles/degree-description/providers/DegreeDescriptionEoiStateProvider';
import { DegreeDescriptionPageAdmissionDeadlinesProvider } from 'bundles/degree-description/providers/DegreeDescriptionPageAdmissionDeadlinesProvider';
import { DegreeDescriptionPageDataProvider } from 'bundles/degree-description/providers/DegreeDescriptionPageDataProvider';
import { DegreeDescriptionPageElementRefsProvider } from 'bundles/degree-description/providers/DegreeDescriptionPageElementRefsProvider';
import { DegreeDescriptionPagePersonalizationProvider } from 'bundles/degree-description/providers/DegreeDescriptionPagePersonalizationProvider';
import DegreeDescriptionPageThemeProvider from 'bundles/degree-description/providers/DegreeDescriptionPageThemeProvider';
import { DegreeDescriptionPageUpsellsProvider } from 'bundles/degree-description/providers/DegreeDescriptionPageUpsellsProvider';
import CourseraMetatagsCms from 'bundles/seo/components/CourseraMetatagsCms';
import UnifiedAppCheckProvider from 'bundles/unified-common/providers/UnifiedAppCheckProvider';
import withMarketingConsent from 'bundles/user-consent/components/withMarketingConsent';

type Props = {
  children?: JSX.Element;
};

const DegreeDescriptionPageRoot: React.FC<Props> = ({ children }) => {
  return (
    <React.Fragment>
      <CourseraMetatagsCms isDegreePage />
      <PingTracker />
      <UnifiedAppCheckProvider>
        <DegreeDescriptionPageDataProvider>
          <DegreeDescriptionPagePersonalizationProvider>
            <DegreeDescriptionPageUpsellsProvider>
              <DegreeDescriptionPageAdmissionDeadlinesProvider>
                <DegreeDescriptionPageThemeProvider>
                  <DegreeDescriptionEoiStateProvider>
                    <DegreeDescriptionPageElementRefsProvider>
                      <ConsumerPageGuard>
                        <DegreePageContent>{children}</DegreePageContent>
                      </ConsumerPageGuard>
                    </DegreeDescriptionPageElementRefsProvider>
                  </DegreeDescriptionEoiStateProvider>
                </DegreeDescriptionPageThemeProvider>
              </DegreeDescriptionPageAdmissionDeadlinesProvider>
            </DegreeDescriptionPageUpsellsProvider>
          </DegreeDescriptionPagePersonalizationProvider>
        </DegreeDescriptionPageDataProvider>
      </UnifiedAppCheckProvider>
    </React.Fragment>
  );
};

export default compose<Props, {}>(
  Retracked.createTrackedContainer<Props, {}>(() => ({
    namespace: {
      app: 'degree_description_app',
      page: 'degree_description_page',
    },
  })),
  withMarketingConsent
)(DegreeDescriptionPageRoot);
